import * as passwordService from '@/services/password'
import * as userService from '@/services/user'
import * as authService from '@/services/auth'
import { SendNew } from '@/services/password'

interface AuthUrlParams {
  personId?: string
  token?: string
  uid?: string
}

export const fetchUserHasOrcasAccess = async ({ commit }: any): Promise<void> => {
  const result: boolean = await userService.fetchUserHasOrcasAccess()
  commit('setUserHasOrcasAccess', result)
}

export const checkResetLinkExpiration = async (
  store: any,
  { personId, token }: AuthUrlParams
): Promise<void> => {
  const data = await passwordService.checkResetLinkExpiration(personId, token)
  store.commit('addPasswordLinkExpirationStatus', data)
}

export const sendPasswordResetEmail = async (
  store: any,
  personId: string
): Promise<void> => {
  store.commit('setPasswordLinkSendingState', true)
  try {
    await passwordService.sendResetEmail(personId)
  } finally {
    store.commit('setPasswordLinkSendingState', false)
  }
}

export const sendNewPassword = async (
  store: any,
  { personId, ...rest }: AuthUrlParams
): Promise<void> => {
  store.commit('setNewPasswordSubmittingState', true)
  try {
    await passwordService.sendNew(rest as SendNew)
    if (personId) await passwordService.updatePersonRegistrationStatus(personId)
  } finally {
    store.commit('setNewPasswordSubmittingState', false)
  }
}

export const sendNewForgottenPassword = async (
  store: any,
  passwordInfo: any
): Promise<void> => {
  store.commit('setNewPasswordSubmittingState', true)
  try {
    await passwordService.sendNewForgotten(passwordInfo)
  } finally {
    store.commit('setNewPasswordSubmittingState', false)
  }
}

// [TODO]: Remove this method from store actions as it doesn't interact with the store.
export const sendForgottenPasswordLinkEmail = async (
  store: any,
  email: string
): Promise<void> => {
  await passwordService.sendForgottenPasswordEmail(email)
}

export const invalidateToken = ({ commit }: any): void => {
  commit('setTokenValidityState', false)
}

export const acceptCookies = async (
  { commit }: any,
  cookies: Array<string>
): Promise<void> => {
  await authService.acceptCookies(cookies)
  commit('setUserCookies', cookies)
}

export const initSelectedCookies = ({ commit, rootState }: any): void => {
  const userCookies = rootState.currentUser.cookies

  if (userCookies) {
    userCookies.forEach(cookie => {
      commit('setCookieSelection', { key: cookie, selected: true })
    })
  }
}
